import { render, staticRenderFns } from "./WxWorkGroup.vue?vue&type=template&id=1c72e1b8&scoped=true&"
import script from "./WxWorkGroup.vue?vue&type=script&lang=js&"
export * from "./WxWorkGroup.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkGroup.vue?vue&type=style&index=0&id=1c72e1b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72e1b8",
  null
  
)

export default component.exports